import React, {useEffect, useMemo, useState} from "react";
import {Settings} from "../../../models/models";
import GenericButton from "../../common/buttons/GenericButton";
import {PAYMENT_METHOD_PAGES, PAYMENT_TYPE} from "../../../constants";
import PaymentMethodCardContainer from "./PaymentMethodCardContainer";
import SelectItem from "../../common/inputs/SelectItem";

const PaymentMethodSplashPage = (props: {
    setData: Function, settings: Settings,
    handleError: Function, setServerResponse: Function,
    setLoading: Function, setPage: Function, page: number, setShouldRefresh: Function
}) => {
    const {
        data, setData, settings, handleError,
        setServerResponse, setLoading, setPage, page, setShouldRefresh
    } = props;
    const {customerId, allPaymentMethods, product} = data;

    const [selectedPaymentType, setSelectedPaymentType] = useState(null);
    const [showPreferredSelectInput, setShowPreferredSelectInput] = useState(false);

    const onAddNewClick = () => {
        setPage(PAYMENT_METHOD_PAGES.ADD_NEW);
    };

    const onSelectPaymentType = (value) => {
        setSelectedPaymentType(value === i18n.common.none ? null : value);
    }

    const onShowPaymentHistoryPage = () => {
        setPage(PAYMENT_METHOD_PAGES.HISTORY);
    }

    const options = useMemo(() => {
        const options = [
            {label: i18n.common.none, value: null}
        ];

        if (settings.hasAppcenterPlan)
            options.push({label: i18n.payments.setAsPreferredAC, value: PAYMENT_TYPE.AC});
        if (settings.hasVRISubscription)
            options.push({label: i18n.payments.setAsPreferredVRI, value: PAYMENT_TYPE.VRI});
        if (settings.hasVDSSubscription)
            options.push({label: i18n.payments.setAsPreferredVDS, value: PAYMENT_TYPE.VDS});

        return options;
    }, [settings]);

    const hideSplashActions = [PAYMENT_METHOD_PAGES.ADD_NEW, PAYMENT_METHOD_PAGES.HISTORY].includes(page);

    return (
        <>
            <div className={"col-12"}>
                <div className={`flexColumn`}>
                    <div className={`flexSpaceBetween`} style={{justifyContent: "end"}}>
                        <GenericButton onClick={onAddNewClick}
                                       hidden={hideSplashActions}
                                       text={i18n.payments.addNewPaymentMethod}/>

                        <GenericButton onClick={onShowPaymentHistoryPage}
                                       hidden={hideSplashActions}
                                       cssClasses={`button-gray`}
                                       text={i18n.payments.paymentHistory}/>
                    </div>
                </div>
            </div>

            {
                showPreferredSelectInput && (
                    <SelectItem
                        text={i18n.payments.setAsPreferred}
                        value={selectedPaymentType}
                        options={options}
                        onChange={onSelectPaymentType}/>
                )
            }

            <PaymentMethodCardContainer data={allPaymentMethods}
                                        setLoading={setLoading}
                                        handleServerError={handleError}
                                        selectedPaymentType={showPreferredSelectInput ? selectedPaymentType : null}
                                        setServerResponse={setServerResponse}
                                        setShouldRefresh={setShouldRefresh}
                                        setPage={setPage}/>
        </>
    );
}

export default PaymentMethodSplashPage;